// * ========================================================================
// * Filter downloadable material by language
// * ========================================================================

'use strict';

import $ from 'jquery';

var selectMaterialLanguage = (function() {

  function init(){


    var pageLang = $('body').data('language');
    var $materialItem = $('.js-downloadable-material-item');
    var regex = '';
    var langs = '';
    //by default show only documents with current page language
    $materialItem.each(function(){
      //filter files for current language
      //dataset data-languages
      // format 'fi,en,sv'
      langs = this.dataset.languages;
      regex = new RegExp('\\b' + pageLang + '\\b');
      if(!langs.match(regex)) $(this).hide();
    });

    //show documents by selected language
    $('.js-lang-select').change(function(){
      var selectedLang = $(this).val();
      if(selectedLang !== 'all'){
        $materialItem.hide();
        $materialItem.each(function(){
          langs = this.dataset.languages; //get data-languages
          regex = new RegExp('\\b' + selectedLang + '\\b');
          if(langs.match(regex)) $(this).show(); //if selected found, show files
        });
      }
      else {
        $materialItem.show();
      }
    });
  }
  return {
    init: init
  }
})();

module.exports = selectMaterialLanguage;
